export const PARAM_KEY_ROADSIDE = "roadside"
export const ROADSIDE_TYPE_URL_PARAM = "roadsideType"
export const ROADSIDE_CONDITION_URL_PARAM = "roadsideCondition"
export const ROADSIDE_TAGS_URL_PARAM = "roadsideTags"